import type { DoctrineId } from '../../data/doctrines.js';
import type { PlayerId, Tick } from '../ids.js';

import type { CommandBase } from './Command.js';

// V1.5 PickDoctrineCommand: a player picks one of three doctrines once per match.
// Validation lives in Simulation.applyCommand:
//   - drop unless MatchState.doctrinePickWindowOpen is true.
//   - drop if the issuing player already has a doctrineId set.
// Once accepted, the player's doctrineId is set and stays set for the match.
export interface PickDoctrineCommand extends CommandBase {
  kind: 'pick_doctrine';
  doctrineId: DoctrineId;
}

export function makePickDoctrineCommand(args: {
  issuedBy: PlayerId;
  tick: Tick;
  doctrineId: DoctrineId;
}): PickDoctrineCommand {
  return {
    kind: 'pick_doctrine',
    issuedBy: args.issuedBy,
    tick: args.tick,
    doctrineId: args.doctrineId,
  };
}
